// utils/jobDetailsPageState.js
//
// Decisions for the JD details page when its data calls fail (Latest JD Version Service, ticket
// sb-monarch-backend#1269). The backend answers HTTP 403 {reason: 'OUT_OF_SCOPE'} when a JD opened by
// link is outside the viewer's view scope. Without this the page stayed on its spinner forever.

export const OUT_OF_SCOPE_REASON = 'OUT_OF_SCOPE';
export const OUT_OF_SCOPE_MESSAGE = 'This job description is outside your view scope.';

export const PAGE_STATE = {
  SPINNER: 'spinner',
  ERROR: 'error',
  CONTENT: 'content',
};

// The message to show for a failed fetch: the scope message for an OUT_OF_SCOPE answer, otherwise
// the generic "<what failed>. Please try again."
export const getFetchErrorMessage = (err, fallbackMessage) =>
  err?.response?.data?.reason === OUT_OF_SCOPE_REASON
    ? OUT_OF_SCOPE_MESSAGE
    : `${fallbackMessage}. Please try again.`;

// Spinner only while there is genuinely nothing to show and nothing has failed; an error with no
// versions shows the error state. A running load keeps the spinner.
export const getPageState = ({ selectedJob, versionData, loading, error }) => {
  const hasVersions = Array.isArray(versionData) && versionData.length > 0;
  if (selectedJob && hasVersions) return PAGE_STATE.CONTENT;
  if (error && !hasVersions && !loading) return PAGE_STATE.ERROR;
  return PAGE_STATE.SPINNER;
};
